// ============================================
// Utils - Number Formatting (ES6)
// 숫자 포맷팅 기능
// ============================================

// 플레이 횟수 포맷팅 (9,999 / 1.0만)
export function formatPlayCount(count) {
  const num = Number(count) || 0;
  if (num >= 10000) {
    const man = num / 10000;
    return man % 1 === 0 ? `${man}만` : `${man.toFixed(1)}만`;
  }
  return num.toLocaleString('ko-KR');
}

// window 노출 제거됨 (2026-01-06) - import로 사용
